export { default } from "./HeaderSlider";



// WEBPACK FOOTER //
// ./src/components/HeaderSlider/index.js